<!--
  pass in layer object:
    mapLayers: list layers in order: the first layer will appear on the top in the map and legend,
        mapId: layer Ids (either number of string)
        customName: to assign custom names to the layers. The source database (mapping portal) may have different layer names.
    Other settings: not include here.
  ==
  props pass to map component:
    allowHideLayer: will control whether to display checkbox to show/hide layers on the map.
-->
<template>
  <div class="columns is-multiline">
    <div class="column is-12-tablet">
      <!-- <div style="visibility:hidden;">
        <alberta-compare-map-text/>
      </div> -->
      <h3 class="my-0">{{ $t("profile.ABStatus.habSuitability.compareMap.header") }}</h3>
      <div class="columns is-centered">
        <div class="column is-9 pb-0">
          <div v-html="$t('profile.ABStatus.habSuitability.compareMap.description', { sppName: state?.sppName, mapYear: state.sppGroup?.habitatMapYear})"> </div>
          <p class="mb-0">
            <a @click="toShowMapDescription = !toShowMapDescription" class="caps is-flex  is-align-items-center">{{ $t("profile.ABStatus.habSuitability.compareMap.interpretHeader", { year: state.year}) }} 
              <span class="icon is-small">
                <svg v-if="toShowMapDescription">
                  <use xlink:href="@/assets/sprite.svg#icon-minus"></use>
                </svg>
                <svg v-else>
                    <use xlink:href="@/assets/sprite.svg#icon-plus"></use>
                </svg>
              </span>
            </a>
          </p>
          <div v-show="toShowMapDescription" v-html="$t('profile.ABStatus.habSuitability.compareMap.detail', { sppName: state?.sppName, mapYear: state.sppGroup?.habitatMapYear })"></div>
        </div>
      </div>
    </div>
    <div class="column is-10-mobile is-12-tablet">
      <div>
        <compare-map :map-config="mapConfig"
        />
      </div>
    </div>
  </div>
  <div class="columns">
    <div class="column is-8-tablet">
    <map-legend :map-type="'compare'" />
    </div>
    <div class="column is-4-tablet">
      <map-legend :map-type="'difference'" />
    </div>
  </div>
  <map-link :map-config="mapConfig" />
</template>

<script>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useApp } from '@/composables/state/profileState';
import AlbertaCompareMap from '@/components/map/AlbertaCompareMap.vue'
import MapLegend from './MapLegend.vue'
import { suitablityMapNames } from '@/config/profile-config.js';
import MapLinks from '@/components/map/MapLinks.vue';

export default {
  name: 'compare-map-section',
  components: {
    'compare-map': AlbertaCompareMap,
    'map-legend': MapLegend,
    'map-link': MapLinks
  },
  setup () {
    const { tm } = useI18n();
    const mapConfig = ref([]);
    suitablityMapNames.forEach(x => {
      mapConfig.value.push({
        name: x,
        title: tm(`profile.ABStatus.habSuitability.${x.toLowerCase()}MapTitle`)
      });
    })

    const { state, sppContent, photoCollection } = useApp();
    const toShowMapDescription = ref(false);
    return {
      state,
      sppContent,
      mapConfig,
      photoCollection,
      toShowMapDescription
    }
  }
}
</script>

<style lang="scss" scoped>
.wideGap .column {
  padding-bottom: 0.5rem;
}
svg {
  width: 20px;
  height: 20px;
}

</style>
